import { useContext, useMemo } from 'react';
import { Class } from 'type-fest';

import { StoresContext } from '@/common/components/StoresProvider/StoresProvider';

// Hook for getting store from StoresProvider.
// Does not support multiple stores with same type in provider context
export function useOptionalStore<T extends Class<Any>>(storeClass: T): Nullable<InstanceType<T>> {
  const storeMap = useContext(StoresContext);

  return useMemo(() => {
    const stores = Object.values(storeMap);

    return (stores.find((store) => store instanceof storeClass) ?? null) as Nullable<InstanceType<T>>;
  }, [storeMap, storeClass]);
}

export default function useStore<T extends Class<Any>>(storeClass: T): InstanceType<T> {
  const store = useOptionalStore(storeClass);

  if (!store) {
    throw new Error(`no store '${storeClass.name}' passed to StoresProvider`);
  }

  return store;
}
